import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BoletoComponent } from './components/boleto/boleto.component';
import { DemonstrativoComponent } from './components/demonstrativo/demonstrativo.component';
import { DiscardComponent } from './components/discard/discard.component';
import { FavoriteComponent } from './components/favorite/favorite.component';
import { FormComponent } from './components/form/form.component';
import { LoginComponent } from './components/login/login.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LoginComponent, data: { logout: true } },
  { path: 'cadastre-se', component: FormComponent },
  { path: 'meus-dados', component: FormComponent },
  // ---------------------------------------
  // TODO: remover daqui há umas 2-3 versões
  { path: 'favoritos', component: FavoriteComponent },
  // ---------------------------------------
  { path: 'imoveis/favoritos', component: FavoriteComponent },
  { path: 'imoveis/descartados', component: DiscardComponent },
  { path: 'boletos', component: BoletoComponent },
  { path: 'demonstrativos', component: DemonstrativoComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ClientRoutingModule {}
